/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 請求サマリー情報。 組織に請求がまったく無い場合は null を返す（API レスポンス全体が null）。 
 * @export
 * @interface GetOrganizationPaymentSummary200Response
 */
export interface GetOrganizationPaymentSummary200Response {
    /**
     * 対象利用月（yyyyMM 形式、例: 202604）。 CardBill / ServiceCharge いずれかが対象としている月。 両方ある場合は同月で一致する（`MonthlyPayment` ドメインで `cardBill.yearMonth == serviceCharge.targetYearMonth` が require() により強制されている）。 
     * @type {number}
     * @memberof GetOrganizationPaymentSummary200Response
     */
    'targetYearMonth': number;
    /**
     * 対象月の請求金額合計（最小通貨単位）。 カード請求（cardBill）+ サービス利用料（serviceCharge）の合算。 MonthlyPayment ドメインに基づく集計。 
     * @type {number}
     * @memberof GetOrganizationPaymentSummary200Response
     */
    'totalAmount': number;
    /**
     * ISO 通貨コード
     * @type {string}
     * @memberof GetOrganizationPaymentSummary200Response
     */
    'currency': string;
    /**
     * 支払予定日（yyyy-MM-dd 形式）。 COMPLETED 以前の状態でサマリーの「支払期限」表示に使用。 
     * @type {string}
     * @memberof GetOrganizationPaymentSummary200Response
     */
    'scheduledPaymentDate': string;
    /**
     * 実際の支払日（yyyy-MM-dd 形式、COMPLETED 後にセット）。 COMPLETED 以前は null。サマリーの「支払日」表示用。 
     * @type {string}
     * @memberof GetOrganizationPaymentSummary200Response
     */
    'paymentDate': string | null;
    /**
     * 支払方法（組織の現在の設定）。 - BANK_TRANSFER: 銀行振込 - ACCOUNT_TRANSFER: 口座振替  ※ 口座振替の振替先機関（MFK / UFJ）の区別は本 API では返さない。 既存 UI でも振替先機関の出し分け表示は行っておらず、本改修のスコープ外。 
     * @type {string}
     * @memberof GetOrganizationPaymentSummary200Response
     */
    'paymentMethod': GetOrganizationPaymentSummary200ResponsePaymentMethodEnum;
    /**
     * サマリーの単一ステータス。 CardBill と ServiceCharge の両方が `COMPLETED` のときに初めて `COMPLETED` とし、 どちらか一方でも未完了なら未完了側を反映する。 未完了側が複数候補ある場合は以下の優先順位で 1 つを選ぶ：    INSUFFICIENT_BALANCE > REQUESTING_EXTERNAL_ACCOUNT_TRANSFER > RESERVED > COMPLETED  優先順位の根拠： - `INSUFFICIENT_BALANCE` は要対応（残高不足）のため最優先で表示 - `REQUESTING_EXTERNAL_ACCOUNT_TRANSFER` は「処理中」を表すため `RESERVED`（予約のみ）より優先 - `COMPLETED` は他に未完了があれば隠す（= 両方完了時のみ表示）  `MonthlyPayment` ドメインの集約パターン（`isPaid` は AND、未完了系フラグは OR）と整合する。 
     * @type {string}
     * @memberof GetOrganizationPaymentSummary200Response
     */
    'latestStatus': GetOrganizationPaymentSummary200ResponseLatestStatusEnum;
}

export const GetOrganizationPaymentSummary200ResponsePaymentMethodEnum = {
    bankTransfer: 'BANK_TRANSFER',
    accountTransfer: 'ACCOUNT_TRANSFER'
} as const;

export type GetOrganizationPaymentSummary200ResponsePaymentMethodEnum = typeof GetOrganizationPaymentSummary200ResponsePaymentMethodEnum[keyof typeof GetOrganizationPaymentSummary200ResponsePaymentMethodEnum];
export const GetOrganizationPaymentSummary200ResponseLatestStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE'
} as const;

export type GetOrganizationPaymentSummary200ResponseLatestStatusEnum = typeof GetOrganizationPaymentSummary200ResponseLatestStatusEnum[keyof typeof GetOrganizationPaymentSummary200ResponseLatestStatusEnum];


